import { gql } from '@apollo/client'

export const CASE_EMAILS_QUERY = gql`
  query caseEmails($caseId: ID!, $direction: CaseEmailDirection, $processingId: ID) {
    caseEmails(caseId: $caseId, direction: $direction, processingId: $processingId) {
      id
      direction
      status
      subject
      bodyHtml
      bodyText
      sanitizedBodyHtml
      fromAddress
      fromName
      toAddresses
      ccAddresses
      bccAddresses
      sentAt
      receivedAt
      readAt
      read
      hasAttachments
      senderUnverified
      errorMessage
      createdAt
      attachments {
        url
        filename
        contentType
      }
      user {
        id
        name
      }
      parentEmail {
        id
        subject
        fromName
      }
    }
  }
`
